module.exports = __webpack_public_path__ + "img/paypal.85c25289.svg";